
class RandomText {

    text: string;
    oldText: string;
    newText: string;
    count: number;

    constructor() {

        this.count=0;
        this.text="";
        this.oldText = "";
        this.newText = "";

    }

    Show(t:string){

        this.count=0;
        this.oldText = this.text;
        this.newText = t;

        
    }

    Update(){
        
        this.text=this.newText;

        /*
        let t:string = "";
        let n:number = this.count;
        let n2:number = this.oldText.length - this.count; 
        let ma:string = "◎";
        if(this.count > this.newText.length) n = this.newText.length;
        if(n2<0){
            n2=0;
            ma="";
        }        
        let nText = this.newText.substr(0,n);
        

        this.text = nText + ma + this.oldText.substr( 0, this.oldText.length-this.count );
        this.count++;
        */
        //console.log(this.text);
    }

}

export {RandomText};